import { client } from '../client'

export async function getAbouts() {
    return await client.fetch('*[_type == "abouts"]')
}

export async function getProjects() {
    return await client.fetch('*[_type == "works"] | order(_createdAt) { _id, title, imgCoverUrl, codeLink, projectLink, tags}[0...6]')
}

export async function getProjectById(id) {
    const query = '*[_id == $id]{introduction, role, period, tasks, description, projectLogo}'
    const params = {id: id}
    return await client.fetch(query, params)
}

export async function getSkills() {
    return await client.fetch('*[_type == "skills"]')
}

export async function getWorkExperiences() {
    return await client.fetch('*[_type == "experiences"] | order(year desc)')
}

export async function createContact(contact) {
    const result = client.create(contact)
    return result;
}